import * as Types from './types';

export function addNotification(type,message){
    return {
        type:Types.SHOW_NOTIFICATION,
        payload:{
            type:type,
            message:message,
            ID:new Date().getTime()
        }
    }
}

export function dismissNotification(){
    return {
        type:Types.DISMISS_NOTIFICATION
    }
}


// WEBPACK FOOTER //
// ./src/actions/notifications.js